// anti-save.js
(() => {
  // Target only product media + main images (adjust selectors as needed)
  const IMG_SELECTOR = [
    '.product__media img',
    '.product-media img',
    '.product-gallery img',
    '.product__modal img',
    'img[data-product-featured-media]',
    'main img'
  ].join(',');

  function protect(img) {
    if (!img || img.dataset.protected === '1') return;
    img.dataset.protected = '1';

    // Block right-click context menu on the image
    img.addEventListener('contextmenu', (e) => e.preventDefault());

    // Block drag-to-desktop / drag-to-new-tab
    img.setAttribute('draggable', 'false');
    img.addEventListener('dragstart', (e) => e.preventDefault());

    // Block long-press actions on many mobile browsers (paired with CSS below)
    img.addEventListener('touchstart', () => {}, { passive: true });
  }

  function scan() {
    document.querySelectorAll(IMG_SELECTOR).forEach(protect);
  }

  // Initial
  scan();

  // Re-scan on dynamic sections / variant changes (common in Shopify themes)
  const obs = new MutationObserver(scan);
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
